import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper } from 'lucide-react';
import { Button } from './ui/button';
import ArticleCard from './ArticleCard';
import { Reveal, RevealGroup } from './motion/Reveal';

const API = process.env.REACT_APP_BACKEND_URL;

const PropertyHubSection = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/hub/articles/featured?limit=3`)
      .then((r) => r.json())
      .then((d) => setArticles(d.articles || []))
      .catch(() => {});
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="py-32 bg-gradient-to-br from-stone-50 to-amber-50/20" data-testid="property-hub-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="text-center mb-16">
          <p className="text-emerald-700 font-medium tracking-wider uppercase text-sm mb-3 flex items-center justify-center gap-2">
            <Newspaper className="h-4 w-4" /> Versatile Property Hub
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 tracking-tight">
            Property News & Insights
          </h2>
          <p className="text-lg text-stone-600 mt-4">
            Property News • Land Updates • Market Insights • Development Alerts
          </p>
        </Reveal>

        <RevealGroup className="grid md:grid-cols-3 gap-8" stagger={0.12}>
          {articles.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
        </RevealGroup>

        <Reveal className="text-center mt-14" delay={0.2}>
          <Button variant="ghost"
            className="text-emerald-700 hover:text-emerald-800 hover:bg-emerald-50 text-lg font-normal px-8 py-6" asChild>
            <Link to="/property-hub" data-testid="explore-property-hub">
              Explore Property Hub <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </Reveal>
      </div>
    </section>
  );
};

export default PropertyHubSection;
